var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessories = function SvgAccessories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "accessories_svg__uuid-8dab9516-2d7b-4206-91be-1d0bc0e0e780",
    width: 55,
    height: 55
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".accessories_svg__uuid-86a779c1-bd09-406f-aa35-c9205efcf332{fill:#fff;fill-rule:evenodd}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    style: {
      fill: "#061e21"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.37 19.28c.18.13.28.33.28.54V34.7c0 .28-.17.52-.43.62l-12.48 4.8a.665.665 0 0 1-.91-.62V24.12c0-.28.18-.54.45-.63l12.48-4.3c.2-.07.43-.04.6.09Zm-12.2 5.31v13.94l11.15-4.29V20.75z",
    className: "accessories_svg__uuid-86a779c1-bd09-406f-aa35-c9205efcf332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.63 19.28c.18-.13.4-.16.6-.09l12.48 4.3c.27.09.45.35.45.63V39.5a.665.665 0 0 1-.91.62l-12.48-4.8a.67.67 0 0 1-.43-.62V19.82c0-.22.1-.42.28-.54Zm1.05 1.48v13.49l11.15 4.29V24.6z",
    className: "accessories_svg__uuid-86a779c1-bd09-406f-aa35-c9205efcf332"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.66 21.72v8.23l-2.88.99v-8.19l-12.87-4.43 3.31-1.91 13.29 4.57c.58.2-.85.12-.85.73Z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.28 14.87c.14-.05.29-.05.44 0l12.48 4.32a.667.667 0 0 1 0 1.26l-12.48 4.3c-.14.05-.29.05-.43 0l-12.48-4.3a.667.667 0 0 1 0-1.26l12.48-4.32Zm-10.22 4.95 10.44 3.59 10.44-3.59-10.44-3.61z",
    className: "accessories_svg__uuid-86a779c1-bd09-406f-aa35-c9205efcf332"
  })));
};
export default SvgAccessories;